import { render, staticRenderFns } from "./ProductsTreeSelect.vue?vue&type=template&id=357c166d&"
import script from "./ProductsTreeSelect.vue?vue&type=script&lang=js&"
export * from "./ProductsTreeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports